/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An AIP created from a Transfer
 * @export
 * @interface AIP
 */
export interface AIP {
    /**
     * Identifier of AIP
     * @type {string}
     * @memberof AIP
     */
    aipId?: string;
    /**
     * 
     * @type {string}
     * @memberof AIP
     */
    status: AIPStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof AIP
     */
    statusUpdatedAt: Date;
    /**
     * Identifier of transfer
     * @type {string}
     * @memberof AIP
     */
    transferId?: string;
}


/**
 * @export
 */
export const AIPStatusEnum = {
    Created: 'Created',
    Validated: 'Validated',
    Failed: 'Failed',
    SentToStorage: 'Sent to Storage',
    Stored: 'Stored',
    DisseminationRequested: 'Dissemination Requested',
    Disseminated: 'Disseminated',
    ReingestRequested: 'Reingest Requested',
    PreProcessing: 'Pre-Processing',
    ReadyForIngest: 'Ready for Ingest',
    Ingesting: 'Ingesting',
    PendingReview: 'Pending Review',
    Rejected: 'Rejected'
} as const;
export type AIPStatusEnum = typeof AIPStatusEnum[keyof typeof AIPStatusEnum];


/**
 * Check if a given object implements the AIP interface.
 */
export function instanceOfAIP(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function AIPFromJSON(json: any): AIP {
    return AIPFromJSONTyped(json, false);
}

export function AIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aipId': !exists(json, 'aip_id') ? undefined : json['aip_id'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'transferId': !exists(json, 'transfer_id') ? undefined : json['transfer_id'],
    };
}

export function AIPToJSON(value?: AIP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aip_id': value.aipId,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'transfer_id': value.transferId,
    };
}

